import { render, staticRenderFns } from "./NewQuestionForm.vue?vue&type=template&id=1b1eb23e&scoped=true"
import script from "./NewQuestionForm.vue?vue&type=script&lang=js"
export * from "./NewQuestionForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=1b1eb23e&prod&scoped=true&lang=css&external"
import style1 from "./NewQuestionForm.vue?vue&type=style&index=1&id=1b1eb23e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1eb23e",
  null
  
)

export default component.exports